<script setup>
import { defineProps, defineEmits} from "vue";
import LinhaDeAdiantamentoResumo from "./LinhaDeAdiantamentoResumo.vue";
import LinhaDeAdiantamentoDetalhes from "./LinhaDeAdiantamentoDetalhes.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "parcela",
    "adiantamento",
]);

const emits = defineEmits([
    "update:alteraAdiantamento",
]);

//==================================================================//
//======================= Altera Adiantamento ======================//
//==================================================================//

const alteraAdiantamento = (update)=>{

    update.parcela = {
        id: props?.parcela?.id
    };
    update.adiantamento = {
        ...update,
        id: props?.adiantamento?.id
    };
    emits('update:alteraAdiantamento',update);

};

</script>

<template>

    <div class="c-table__row-group">

        <LinhaDeAdiantamentoResumo
            :dado="props?.dado"
            :parcela="props?.parcela"
            :adiantamento="props?.adiantamento"
            @update:alteraAdiantamento="alteraAdiantamento"
        ></LinhaDeAdiantamentoResumo>

        <LinhaDeAdiantamentoDetalhes
            :dado="props?.dado"
            :parcela="props?.parcela"
            :adiantamento="props?.adiantamento"
        ></LinhaDeAdiantamentoDetalhes>

    </div>

</template>

<style scoped>

.c-table__row-group{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>